import redux from './redux';

export default { redux };
